import { ShoppingCart } from 'lucide-react';
import { Link } from 'react-router-dom';

import { useTranslation } from '@sshop/i18n';

import { useCart } from '@/features/cart';
import { useLocale } from '@/shared/hooks/useLocale';
import { routes } from '@/shared/lib/routes';

import { cartButtonStyles as s } from './CartButton.styles';

export function CartButton() {
  const { t } = useTranslation();
  const locale = useLocale();
  const { data: cart } = useCart();
  const count = cart?.itemCount ?? 0;
  const display = count > 99 ? '99+' : String(count);

  return (
    <Link to={routes.cart(locale)} aria-label={t('nav.cart')} className={s.root}>
      <ShoppingCart className={s.icon} aria-hidden />
      {count > 0 && (
        <span className={s.badge} aria-hidden>
          {display}
        </span>
      )}
    </Link>
  );
}
